import { render, staticRenderFns } from "./BtnLimpar.vue?vue&type=template&id=016deac9"
import script from "./BtnLimpar.vue?vue&type=script&lang=js"
export * from "./BtnLimpar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports